import {
    CURRENCIES_AVAILABLE_INFO,
    TRANSACTION_TYPE
} from '@constants/constants';

export const isCurrencyValid = (targetCurrency) => {
    return (
        -1 !==
        Object.keys(CURRENCIES_AVAILABLE_INFO).findIndex((currencyKey) => {
            return (
                CURRENCIES_AVAILABLE_INFO[currencyKey].NAME === targetCurrency
            );
        })
    );
};

export const isTransactionTypeValid = (targetTransactionType) => {
    return (
        -1 !==
        Object.keys(TRANSACTION_TYPE).findIndex((transactionTypeKey) => {
            return (
                TRANSACTION_TYPE[transactionTypeKey] === targetTransactionType
            );
        })
    );
};
